import { render, staticRenderFns } from "./add-set-meal.vue?vue&type=template&id=72cf692c&scoped=true&"
import script from "./add-set-meal.vue?vue&type=script&lang=ts&"
export * from "./add-set-meal.vue?vue&type=script&lang=ts&"
import style0 from "./add-set-meal.vue?vue&type=style&index=0&lang=stylus&module=true&"
import style1 from "./add-set-meal.vue?vue&type=style&index=1&id=72cf692c&lang=stylus&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "72cf692c",
  null
  
)

export default component.exports